exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".timelineCard-218fd{background-color:#fff;box-shadow:0 0 3px #ccc;border-radius:4px;padding:10px}", ""]);

// Exports
exports.locals = {
	"timelineCard": "timelineCard-218fd"
};